import React, {useState, useEffect} from "react";
import "./Fading.css";

export default function TextYoutube(props) {
  const height= window.innerHeight/2;


  useEffect(() => {
    const height= window.innerHeight/2;
  }, []);

  return (
    <div style={{ 
        backgroundColor: "black", 
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "30px 20px 30px 20px"

    }}>
      <iframe
        height= {height}
        width="600px"
        src={props.src}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        // allowfullscreen
      ></iframe>
    </div>
  );
}
